import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, Transition as _Transition, createSlots as _createSlots, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50ab4dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spinner-container"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BookingStepper = _resolveComponent("BookingStepper")!
  const _component_BookingHeader = _resolveComponent("BookingHeader")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_BookingNav = _resolveComponent("BookingNav")!
  const _component_BookingBasket = _resolveComponent("BookingBasket")!
  const _component_BaseBookingLayout = _resolveComponent("BaseBookingLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BookingStepper),
    _createVNode(_component_BaseBookingLayout, { mainColumnWidth: _ctx.mainColumnWidth }, _createSlots({
      main: _withCtx(() => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_BookingHeader),
                  _createVNode(_component_BaseSpinner, { size: 50 })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_BookingNav, { loadingStep: _ctx.loadingStep }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeComponent), { ref: "stepComponent" }, null, 512))
                    ]),
                    _: 1
                  }, 8, ["loadingStep"])
                ]))
          ]),
          _: 1
        })
      ]),
      _: 2
    }, [
      (!_ctx.isPayment)
        ? {
            name: "aside",
            fn: _withCtx(() => [
              _createVNode(_Transition, { name: "slide" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BookingBasket, { class: "basket" })
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["mainColumnWidth"])
  ], 64))
}